export enum ScheduleType {
  Project = "PROJECT",
  Development = "DEVELOPMENT",
  Template = "TEMPLATE",
}
